"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParsedMessageRegExp = exports.ParsedMessage = void 0;
const abnf_1 = require("./abnf");
Object.defineProperty(exports, "ParsedMessage", { enumerable: true, get: function () { return abnf_1.ParsedMessage; } });
const regex_1 = require("./regex");
Object.defineProperty(exports, "ParsedMessageRegExp", { enumerable: true, get: function () { return regex_1.ParsedMessage; } });
